import React from 'react';
interface GoogleSignInButtonProps {
  onClick: () => void;
  loading?: boolean;
  text?: string;
}
export function GoogleSignInButton({
  onClick,
  loading = false,
  text = 'Continue with Google'
}: GoogleSignInButtonProps) {
  return <button type="button" onClick={onClick} disabled={loading} className="w-full flex items-center justify-center gap-3 px-4 py-3 border-2 border-gray-300 rounded-lg font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-805" data-mp="5ymqpfk4nbje">
      {loading ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-700" data-id="element-806" data-mp="3je1664tmovd6"></div> : <>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" data-id="element-807" data-mp="3eeg6ttajqkzx">
            <path d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z" fill="#4285F4" data-id="element-808" data-mp="3ehapbfa01vqp" />
            <path d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z" fill="#34A853" data-id="element-809" data-mp="1hdpakdcfhzlk" />
            <path d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z" fill="#FBBC05" data-id="element-810" data-mp="1qdvn9x0ayvjo" />
            <path d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.19 5.736 7.395 3.977 10 3.977z" fill="#EA4335" data-id="element-811" data-mp="xqhlnllntbt8" />
          </svg>
          <span data-id="element-812" data-mp="17mkxxka86qtw">{text}</span>
        </>}
    </button>;
}